import { getFontScale } from 'mini-app-module-store/lib/selectors/getFontScale';
/***
 * Reduce a given value in increments, depending on fontScale. This is useful for top, height and other properties that control placement,
 * that we wish to gradually change depending on the fontScale.
 * The maxValue is the maximum value that the element can have, usually the default height of the element
 * The valueToProgressivelyReduce is the maximum value we can remove from the element (in case of capping the fontScale)
 * The capFontScale is a boolean that indicates whether we want to cap the fontScale or not - capping the fontScale means that the fontScale will never be lesser than 1
 */

export const progressiveSizeReduce = (
    maxValue: number,
    valueToProgressivelyReduce: number,
    capFontScale: boolean = false
) =>
    (maxValue - valueToProgressivelyReduce / getFontScaleForSizeReduction(capFontScale)).toString();

/***
 * Returns the fontScale to be used for calculating the size we must reduce the element to
 */
const getFontScaleForSizeReduction = (capFontScale: boolean = false) =>
    capFontScale ? Math.max(getFontScale(), 1) : getFontScale();
